import { formatSalesOrderNumber } from '@order-management/format';
import { SalesOrder } from '@order-management/types';
import { useMemo } from 'react';
import { Element } from 'react-bulma-components';
import InboxItem from '../../ui/inbox-table/inbox-item/inbox-item';

export type SalesOrderInboxItemProps = {
  salesOrder: SalesOrder;
  onClick: () => void;
  active: boolean;
};

export function SalesOrderInboxItem({
  active,
  onClick,
  salesOrder,
}: SalesOrderInboxItemProps) {
  const subtitle = useMemo(() => {
    const endUserSoftwareContact = salesOrder.endUser;
    const account = salesOrder.opportunity?.account?.name;
    const opportunityName = salesOrder.opportunity?.name;

    if (!endUserSoftwareContact && !account && !opportunityName) return null;

    let subtitleText = endUserSoftwareContact;
    const subtitleClassName = 'is-size-7';

    if (!account && !opportunityName) {
      return (
        <Element>
          <span className={subtitleClassName}>{`${subtitleText} - `}</span>
          <span className={`${subtitleClassName} is-italic`}>
            No opportunity
          </span>
        </Element>
      );
    }

    if (account) {
      subtitleText = `${subtitleText} - ${account}`;
    }

    if (opportunityName) {
      subtitleText = `${subtitleText} - ${opportunityName}`;
    }

    return <span className={subtitleClassName}>{subtitleText}</span>;
  }, [
    salesOrder.endUser,
    salesOrder.opportunity?.account?.name,
    salesOrder.opportunity?.name,
  ]);

  return (
    <InboxItem active={active} onClick={onClick}>
      <Element display="flex" flexDirection="column" className="gap-1">
        <span>{formatSalesOrderNumber(salesOrder.number)}</span>
        {subtitle}
      </Element>
    </InboxItem>
  );
}

export default SalesOrderInboxItem;
